export const formatPercent = (
  value: number | undefined | null,
  precision = 0,
) => {
  if (value === undefined || value === null) {
    return ""
  }

  return `${(value * 100).toFixed(precision)}%`
}

export const formatPrice = (
  value: number | undefined | null,
  precision = 6,
) => {
  if (value === undefined || value === null) {
    return ""
  }

  return (
    "$" +
    value.toLocaleString(undefined, {
      minimumFractionDigits: precision,
      maximumFractionDigits: precision,
    })
  )
}

export const maybeNumber = (value: string | undefined | null) => {
  const numeric = !value ? undefined : parseFloat(value)

  return Number.isNaN(numeric) ? undefined : numeric
}

export const msToSeconds = (durationMs: number, fractionDigits = 0) =>
  (durationMs / 1000).toFixed(fractionDigits)

export const formatBytes = (bytes: number): string => {
  if (bytes === 0) {
    return "0 bytes"
  }
  const units = ["bytes", "KB", "MB", "GB", "TB"]
  const i = Math.min(
    Math.floor(Math.log(bytes) / Math.log(1024)),
    units.length - 1,
  )
  const value = bytes / 1024 ** i

  return `${i === 0 ? value : value.toFixed(1)} ${units[i]}`
}

export const niceDelay = (delay: "short" | "long" | number) =>
  typeof delay === "number" ? delay : Math.E * (delay === "short" ? 100 : 1000)
